export const lightGray = "#f6f6f6";
export const black = "#212121";
export const blue = "#0050A4";
export const navy = "#0C0D3E";
export const white = "#fff";
export const darkGreen = "#0b4741";
export const green = "#4caf50";
export const teal = "#009688";
